import { useMutation } from "react-query";

import { useAuthContext } from "@hooks/useAuthContext";
import { logout } from "@services/authentication.service";

export const useLogout = () => {
    const { disconnect } = useAuthContext();

    return useMutation(() => logout(),
        {
            onSuccess: () => {
                disconnect();
            },
            onError: () => {
                disconnect();
            }
        }
    );
}